import React from 'react'
import WriteNow from './WriteNow'

const WriteCode = () => {
  return (
    <WriteNow programming={true}/>
  )
}

export default WriteCode